import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-account-number-page-ui',
    template: '',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbAccountNumberPageComponent {}
